import React, {useCallback} from "react";
import {useParams} from "react-router-dom";
import {useTypedSelector} from "../../../../redux/Hooks/storeSelectors";
import {selectMapLayerIdByEntityName} from "../../../../redux/selectors/selectors";
import EntityEditor from "../../../../components/Entities/EntityEditor";
import {RoadInfrastructureEntityName} from "../../../../api/types/types";


const RoadEdit = () => {
    const entityName = RoadInfrastructureEntityName.Road;
    const layerToReloadEntityName = RoadInfrastructureEntityName.RoadSegment;
    const {roadId} = useParams<any>();
    const sourceId = useTypedSelector((state) => selectMapLayerIdByEntityName(state, layerToReloadEntityName));

    const onSaveFn = useCallback((entity: any) => {
        if (roadId) {
            return `../../${entity.id}/edit`;
        }
        return `../${entity.id}/edit`;
    }, [roadId]);

    const onDeleteFn = useCallback(() => '../../', []);

    return (
        <EntityEditor
            entityId={roadId!}
            entityName={entityName}
            layerId={sourceId}
            presetProperty={'roadInfrastructurePreset'}
            getUrlOnSaveFn={onSaveFn}
            getUrlOnDeleteFn={onDeleteFn}
            showDeleteBtn={!!roadId}
        />
    )
}

export default RoadEdit;